import { FaFacebook } from "react-icons/fa";
import { FaSnapchat } from "react-icons/fa";
import { FaSquareInstagram } from "react-icons/fa6";

export default function Footer() {
  return (
    <footer className="w-full bg-gray-100 text-gray-800">
      {/* Top Section: Location + Nav + Socials */}
      <div className="max-w-6xl mx-auto px-4 py-6 flex flex-col md:flex-row md:items-start md:justify-between">
        
        {/* Left: Our Location */}
        <div className="mb-6 md:mb-0">
          <h2 className="font-bold text-lg text-blue-800">Our location</h2>
          <p className="mt-2 text-sm text-gray-700 leading-relaxed">
            369 2 Duangdee Rd, Tambon Noen Phra, Mueang
            <br />
            Rayong District, Rayong 21000
          </p>
        </div>

        {/* Right: Nav Links + Icons */}
        <div className="flex flex-col md:items-center md:flex-row md:space-x-8">
          <nav className="flex space-x-6 text-sm mb-4 md:mb-0">
            <a href="#" className="hover:text-blue-600">Home</a>
            <a href="#" className="hover:text-blue-600">Products</a>
            <a href="#" className="hover:text-blue-600">Sale</a>
            <a href="#" className="hover:text-blue-600">Cart</a>
            <a href="#" className="hover:text-blue-600">Checkout</a>
          </nav>
          <div className="flex space-x-4 text-xl text-blue-800">
            <FaFacebook className="hover:text-blue-600 cursor-pointer" />
            <FaSquareInstagram className="hover:text-pink-500 cursor-pointer" />
            <FaSnapchat className="hover:text-yellow-500 cursor-pointer" />
          </div>
        </div>
      </div>

      {/* Divider */}
      <hr className="border-blue-200" />

      {/* Bottom Section: Privacy Policy + Copyright + Terms */}
      <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-between text-xs md:text-sm">
        {/* Left: Privacy Policy */}
        <div className="order-2 md:order-1 mt-2 md:mt-0">
          <a href="#" className="text-gray-600 hover:text-blue-600">
            Privacy Policy
          </a>
        </div>

        {/* Center: Copyright */}
        <div className="order-1 md:order-2 font-bold text-center">
          &copy; 2024 Pornkamon Rice Flour Mills Co., Ltd. All rights reserved.
        </div>

        {/* Right: Terms & Conditions */}
        <div className="order-3 md:order-3 mt-2 md:mt-0">
          <a href="#" className="text-gray-600 hover:text-blue-600">
            Terms & Conditions
          </a>
        </div>
      </div>
    </footer>
  );
}
